<template>
  <div class="alipay-home">
    <!-- 欢迎横幅 -->
    <div class="welcome-banner">
      <div class="banner-content">
        <div class="greeting">
          <h2>欢迎回来，{{ userName }}</h2>
          <p>愿你今天有个好心情</p>
        </div>
        <div class="banner-date">
          <div class="date">{{ currentDate }}</div>
          <div class="week">{{ currentWeek }}</div>
        </div>
      </div>
      <div class="banner-stats">
        <div class="stat-item">
          <span class="stat-num">{{ todayOrderCount }}</span>
          <span class="stat-label">今日订单</span>
        </div>
        <div class="stat-item">
          <span class="stat-num">{{ todayIncome }}</span>
          <span class="stat-label">今日收入(元)</span>
        </div>
        <div class="stat-item">
          <span class="stat-num">{{ pendingCount }}</span>
          <span class="stat-label">待处理事项</span>
        </div>
      </div>
    </div>

    <!-- 数据统计卡片 -->
    <div class="stat-cards">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="12" :md="6" v-for="item in countData" :key="item.name">
          <div class="stat-card" :class="item.className">
            <div class="stat-icon">
              <i :class="`el-icon-${item.icon}`"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ formatNumber(item.value) }}</div>
              <div class="stat-label">{{ item.name }}</div>
              <div class="stat-trend" v-if="item.trend !== undefined">
                <i :class="item.trend >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                <span :style="{ color: item.trend >= 0 ? '#00b578' : '#ff4d4f' }">{{ Math.abs(item.trend) }}%</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 主要内容区 -->
    <el-row :gutter="20">
      <!-- 左侧 - 常用功能 -->
      <el-col :xs="24" :sm="24" :md="8">
        <el-card class="function-card" shadow="never">
          <div class="card-header">
            <i class="el-icon-star-on"></i>
            <span>常用功能</span>
            <span class="more-btn" @click="goMoreFunctions">更多功能</span>
          </div>

          <section class="function-list" v-if="cmpInfo.CompanyCD=='JM0001'">
            <div class="function-item" @click="goChub">
              <div class="function-icon hub"><i class="el-icon-s-cooperation"></i></div>
              <span class="function-name">轮毂合成</span>
            </div>
            <div class="function-item" @click="goUrl('/simpleGoodsList')">
              <div class="function-icon wheel"><i class="el-icon-s-goods"></i></div>
              <span class="function-name">轮毂</span>
            </div>
            <div class="function-item" @click="goUrl('/carPitchList')">
              <div class="function-icon pitch"><i class="el-icon-s-marketing"></i></div>
              <span class="function-name">孔距</span>
            </div>
            <div class="function-item" @click="goUrl('/newsList')">
              <div class="function-icon article"><i class="el-icon-document"></i></div>
              <span class="function-name">文章信息</span>
            </div>
            <div class="function-item" @click="goUrl('/goodsCategoryList')">
              <div class="function-icon category"><i class="el-icon-folder"></i></div>
              <span class="function-name">轮毂分类</span>
            </div>
            <div class="function-item" @click="goUrl('/carList')">
              <div class="function-icon car"><i class="el-icon-s-cooperation"></i></div>
              <span class="function-name">车辆信息</span>
            </div>
          </section>
           <section class="function-list" v-if="cmpInfo.CompanyCD!='JM0001'">
            <div class="function-item">
              <div class="function-icon hub"><i class="el-icon-s-cooperation"></i></div>
              <span class="function-name">商户信息</span>
            </div>
            <div class="function-item" @click="goUrl('/simpleGoodsList')">
              <div class="function-icon wheel"><i class="el-icon-s-goods"></i></div>
              <span class="function-name">客户信息</span>
            </div>
            <div class="function-item" >
              <div class="function-icon pitch"><i class="el-icon-s-marketing"></i></div>
              <span class="function-name">产品列表</span>
            </div>
            <div class="function-item" @click="goUrl('/newsList')">
              <div class="function-icon article"><i class="el-icon-document"></i></div>
              <span class="function-name">文章信息</span>
            </div>
            <div class="function-item" >
              <div class="function-icon category"><i class="el-icon-folder"></i></div>
              <span class="function-name">供应需求</span>
            </div>
            <div class="function-item" >
              <div class="function-icon car"><i class="el-icon-s-cooperation"></i></div>
              <span class="function-name">展会信息</span>
            </div>
          </section>
          
        </el-card>

        <!-- 待办事项卡片 -->
        <el-card class="todo-card" shadow="never" style="margin-top: 20px">
          <div class="card-header">
            <i class="el-icon-s-order"></i>
            <span>待办事项</span>
          </div>
          <div class="todo-list">
            <div class="todo-item" v-for="item in todoList" :key="item.title" @click="handleTodo(item)">
              <i :class="item.icon"></i>
              <span class="todo-title">{{ item.title }}</span>
              <span class="todo-badge" :class="item.badgeType">{{ item.badge }}</span>
              <el-button type="text" size="small">处理</el-button>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧 - 图表区 -->
      <el-col :xs="24" :sm="24" :md="16">
        <el-card class="chart-card" shadow="never">
          <div class="card-header">
            <i class="el-icon-data-line"></i>
            <span>销售趋势分析</span>
            <el-dropdown class="chart-tool" @command="handleChartCommand">
              <span class="el-dropdown-link">{{ chartTime }} <i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="week">本周</el-dropdown-item>
                <el-dropdown-item command="month">本月</el-dropdown-item>
                <el-dropdown-item command="year">本年</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div id="line-chart" class="chart-container" v-loading="chartLoading"></div>
        </el-card>

        <!-- 双图表 -->
        <el-row :gutter="20" class="double-charts" style="margin-top: 20px">
          <el-col :xs="24" :sm="24" :md="12">
            <el-card class="small-chart-card" shadow="never">
              <div class="card-header">
                <i class="el-icon-s-data"></i>
                <span>热门商品排行</span>
              </div>
              <div id="bar-chart" class="small-chart" v-loading="chartLoading"></div>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-card class="small-chart-card" shadow="never">
              <div class="card-header">
                <i class="el-icon-pie-chart"></i>
                <span>销售品类占比</span>
              </div>
              <div id="pie-chart" class="small-chart" v-loading="chartLoading"></div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 最近订单 -->
        <el-card class="order-card" shadow="never" style="margin-top: 20px">
          <div class="card-header">
            <i class="el-icon-document"></i>
            <span>最近订单</span>
            <span class="more-btn" @click="goUrl('/orderList')">查看全部</span>
          </div>
          <el-table :data="recentOrders" size="small" class="recent-table" :show-header="false">
            <el-table-column prop="order_sn" label="订单号" min-width="180">
              <template slot-scope="scope">
                <span class="order-sn">{{ scope.row.order_sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_amount" label="金额" width="100">
              <template slot-scope="scope">
                <span class="order-amount">¥{{ scope.row.order_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
              <template slot-scope="scope">
                <el-tag :type="getOrderStatusType(scope.row.order_status)" size="mini">
                  {{ getOrderStatusText(scope.row.order_status) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'


export default {
  name: "WelcomeView",
  data() {
    return {
      cmpInfo:{
        CompanyCD:"",

      },
      userName: sessionStorage.getItem('creator_name') || '管理员',
      chartTime: '本周',
      chartLoading: false,
      
      currentDate: '',
      currentWeek: '',
      
      // 统计数据
      todayOrderCount: 0,
      todayIncome: 0,
      pendingCount: 0,
      
      countData: [],
      
      todoList: [
        { title: "待发货订单", icon: "el-icon-truck", badge: "0", badgeType: "warning", path: "/shippingOrderList" },
        { title: "待处理售后", icon: "el-icon-chat-dot-round", badge: "0", badgeType: "danger", path: "/orderRefundList" },
        { title: "库存预警", icon: "el-icon-warning", badge: "0", badgeType: "info", path: "/goodsList" },
      ],
      
      recentOrders: [],
      
      // 图表实例
      lineChart: null,
      barChart: null,
      pieChart: null,
      
      // 图表数据
      lineData: {
        week: { xAxis: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'], orders: [0, 0, 0, 0, 0, 0, 0], income: [0, 0, 0, 0, 0, 0, 0] },
        month: { xAxis: [], orders: [], income: [] },
        year: { xAxis: [], orders: [], income: [] }
      },
      barData: [],
      pieData: []
    }
  },
  mounted() {
    this.getCurrentDate()
  
    this.getCompany();
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.lineChart) this.lineChart.dispose()
    if (this.barChart) this.barChart.dispose()
    if (this.pieChart) this.pieChart.dispose()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getCurrentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      this.currentDate = `${year}.${month}.${day}`
      const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      this.currentWeek = weeks[now.getDay()]
    },
    
    formatNumber(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      }
      return num.toString()
    },
    
    // 初始化所有数据
    async initAllData() {
      await Promise.all([
        this.getCountData(),
        this.getTodayStats(),
        this.getLineChartData('week'),
        this.getBarChartData(),
        this.getPieChartData(),
        this.getRecentOrders()
      ])
      this.initCharts()
    },
    
    // 获取统计数据
    async getCountData() {
      try {

        let param = {
                            access_token: sessionStorage.getItem('token'),
                            company_id: sessionStorage.getItem('company_id'),
                          
                        };

        const res = await this.$axios.findDashboardCount(param)
        if (res.code == 200) {
          this.countData[0].value = res.data[0].value || 0
          this.countData[1].value = res.data[1].value || 0
          this.countData[2].value = res.data[2].value || 0
          this.countData[3].value = res.data[3].value || 0
          
          // 更新待办事项数量
          this.todoList[0].badge = res.data.pendingOrderCount || 0
          this.todoList[1].badge = res.data.pendingRefundCount || 0
          this.todoList[2].badge = res.data.lowStockCount || 0
        }
      } catch (error) {
        // 使用模拟数据
        this.countData[0].value = 128
        this.countData[1].value = 45
        this.countData[2].value = 32
        this.countData[3].value = 67
        this.todoList[0].badge = 5
        this.todoList[1].badge = 2
        this.todoList[2].badge = 8
      }
    },
    
    // 获取今日统计
    async getTodayStats() {
      try {
        const res = await this.$axios.getTodayStats({})
        if (res.code == 200) {
          this.todayOrderCount = res.data.orderCount || 0
          this.todayIncome = res.data.income || 0
          this.pendingCount = res.data.pendingCount || 0
        }
      } catch (error) {
        this.todayOrderCount = 0
        this.todayIncome = 0
        this.pendingCount = 0
      }
    },
    
    // 获取折线图数据
    async getLineChartData(type) {
      try {
        const res = await this.$axios.getSalesTrend({ type: type })
        if (res.code == 200) {
          if (type === 'week') {
            this.lineData.week.orders = res.data.orders || [0, 0, 0, 0, 0, 0, 0]
            this.lineData.week.income = res.data.income || [0, 0, 0, 0, 0, 0, 0]
          } else if (type === 'month') {
            this.lineData.month.xAxis = res.data.days || []
            this.lineData.month.orders = res.data.orders || []
            this.lineData.month.income = res.data.income || []
          } else {
            this.lineData.year.xAxis = res.data.months || []
            this.lineData.year.orders = res.data.orders || []
            this.lineData.year.income = res.data.income || []
          }
        }
      } catch (error) {
        // 模拟数据
        if (type === 'week') {
          this.lineData.week.orders = [12, 18, 15, 22, 28, 35, 30]
          this.lineData.week.income = [1200, 1800, 1500, 2200, 2800, 3500, 3000]
        }
      }
    },
    
    // 获取柱状图数据
    async getBarChartData() {
      try {
        const res = await this.$axios.getHotProducts({})
        if (res.code == 200) {
          this.barData = res.data || []
        }
      } catch (error) {
        this.barData = [
          { name: '18寸轮毂', value: 125 },
          { name: '19寸轮毂', value: 98 },
          { name: '20寸轮毂', value: 156 },
          { name: '21寸轮毂', value: 87 },
          { name: '22寸轮毂', value: 132 }
        ]
      }
    },
   async getCompany(){
          let param = {
                            access_token: sessionStorage.getItem('token'),
                            company_id: sessionStorage.getItem('company_id'),
                          
                        };
        const res = await this.$axios.findCompanyOne(param)
        if (res.code == 200) {
              this.cmpInfo=res.data;
              if(this.cmpInfo.CompanyCD=="JM0001"){
                this.countData=[
        { name: '轮毂数量', value: 0, icon: "s-goods", className: "hub", trend: 12 },
        { name: "汽车数量", value: 0, icon: "s-cooperation", className: "car", trend: 8 },
        { name: "孔距数量", value: 0, icon: "s-marketing", className: "pitch", trend: -3 },
        { name: "文章数量", value: 0, icon: "document", className: "article", trend: 15 },
      ];
              }else{
                 this.countData=[
              { name: '商户数量', value: 0, icon: "s-goods", className: "hub", trend: 12 },
              { name: "客户数量", value: 0, icon: "s-cooperation", className: "car", trend: 8 },
              { name: "需求数量", value: 0, icon: "s-marketing", className: "pitch", trend: -3 },
              { name: "文章数量", value: 0, icon: "document", className: "article", trend: 15 },
              ];
              }
              this.initAllData();
        }
    },
    // 获取饼图数据
    async getPieChartData() {
      try {
        const res = await this.$axios.getCategoryRatio({})
        if (res.code == 200) {
          this.pieData = res.data || []
        }
      } catch (error) {
        this.pieData = [
          { name: '运动轮毂', value: 35 },
          { name: '豪华轮毂', value: 25 },
          { name: '越野轮毂', value: 20 },
          { name: '改装轮毂', value: 12 },
          { name: '原厂轮毂', value: 8 }
        ]
      }
    },
    
    // 获取最近订单
    async getRecentOrders() {
      try {
        const res = await this.$axios.getRecentOrders({ limit: 5 })
        if (res.code == 200) {
          this.recentOrders = res.data || []
        }
      } catch (error) {
        this.recentOrders = [
          { order_sn: 'DD202312010001', order_amount: 0, order_status: 0 },
          { order_sn: 'DD202312010002', order_amount: 0, order_status: 1 },
          { order_sn: 'DD202312010003', order_amount: 0, order_status: 2 },
          { order_sn: 'DD202312010004', order_amount: 0, order_status: 0 },
          { order_sn: 'DD202312010005', order_amount: 0, order_status: 1 }
        ]
      }
    },
    
    // 初始化所有图表
    initCharts() {
      this.initLineChart()
      this.initBarChart()
      this.initPieChart()
    },
    
    initLineChart() {
      const dom = document.getElementById('line-chart')
      if (!dom) return
      
      if (this.lineChart) this.lineChart.dispose()
      this.lineChart = echarts.init(dom)
      
      const data = this.lineData.week
      this.lineChart.setOption({
        grid: { top: 40, left: 50, right: 30, bottom: 30, containLabel: true },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { data: ['订单数', '销售额(百元)'], right: 10, itemWidth: 25, itemHeight: 14, textStyle: { color: '#606266' } },
        xAxis: { type: 'category', data: data.xAxis, axisLine: { lineStyle: { color: '#e4e7ed' } }, axisLabel: { fontSize: 12 } },
        yAxis: { type: 'value', name: '数量', nameTextStyle: { color: '#8c8f98' }, splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } } },
        series: [
          { name: '订单数', type: 'line', smooth: true, data: data.orders, symbol: 'circle', symbolSize: 8, lineStyle: { width: 3, color: '#1677ff' }, areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(22,119,255,0.3)' }, { offset: 1, color: 'rgba(22,119,255,0.05)' }]) }, itemStyle: { color: '#1677ff', borderColor: '#fff', borderWidth: 2 } },
          { name: '销售额(百元)', type: 'line', smooth: true, data: data.income, symbol: 'circle', symbolSize: 8, lineStyle: { width: 3, color: '#00b578' }, areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(0,181,120,0.3)' }, { offset: 1, color: 'rgba(0,181,120,0.05)' }]) }, itemStyle: { color: '#00b578', borderColor: '#fff', borderWidth: 2 } }
        ]
      })
    },
    
    initBarChart() {
      const dom = document.getElementById('bar-chart')
      if (!dom) return
      
      if (this.barChart) this.barChart.dispose()
      this.barChart = echarts.init(dom)
      
      this.barChart.setOption({
        grid: { top: 40, left: 55, right: 20, bottom: 30, containLabel: true },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        xAxis: { type: 'category', data: this.barData.map(item => item.name), axisLabel: { rotate: 20, fontSize: 11 }, axisLine: { lineStyle: { color: '#e4e7ed' } } },
        yAxis: { type: 'value', name: '销量', nameTextStyle: { color: '#8c8f98' }, splitLine: { lineStyle: { color: '#f0f0f0' } } },
        series: [{ name: '销量', type: 'bar', data: this.barData.map(item => item.value), barWidth: '50%', itemStyle: { borderRadius: [6, 6, 0, 0], color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#1677ff' }, { offset: 1, color: '#69a5ff' }]) }, label: { show: true, position: 'top', formatter: '{c}', fontSize: 11 } }]
      })
    },
    
    initPieChart() {
      const dom = document.getElementById('pie-chart')
      if (!dom) return
      
      if (this.pieChart) this.pieChart.dispose()
      this.pieChart = echarts.init(dom)
      
      const colors = ['#1677ff', '#00b578', '#ffb980', '#ef705a', '#9270ca']
      const pieData = this.pieData.map((item, index) => ({ ...item, itemStyle: { color: colors[index % colors.length] } }))
      
      this.pieChart.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {d}%' },
        legend: { orient: 'vertical', right: 10, top: 20, textStyle: { fontSize: 12 }, itemWidth: 12, itemHeight: 12 },
        series: [{ name: '品类分布', type: 'pie', radius: ['45%', '65%'], center: ['40%', '50%'], avoidLabelOverlap: false, label: { show: false }, emphasis: { scale: true, label: { show: true, formatter: '{b}: {d}%', fontSize: 12, fontWeight: 'bold' } }, data: pieData, itemStyle: { borderRadius: 8, borderColor: '#fff', borderWidth: 2 } }]
      })
    },
    
    async handleChartCommand(command) {
      const timeMap = { week: '本周', month: '本月', year: '本年' }
      this.chartTime = timeMap[command] || '本周'
      this.chartLoading = true
      
      await this.getLineChartData(command)
      
      if (this.lineChart) {
        const data = command === 'week' ? this.lineData.week : (command === 'month' ? this.lineData.month : this.lineData.year)
        this.lineChart.setOption({
          xAxis: { data: data.xAxis },
          series: [
            { data: data.orders },
            { data: data.income }
          ]
        })
      }
      this.chartLoading = false
    },
    
    handleResize() {
      if (this.lineChart) this.lineChart.resize()
      if (this.barChart) this.barChart.resize()
      if (this.pieChart) this.pieChart.resize()
    },
    
    handleTodo(item) {
      if (item.path) this.$router.push(item.path)
    },
    
    getOrderStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'info', 6: 'primary', 7: 'success' }
      return map[status] || 'info'
    },
    
    getOrderStatusText(status) {
      const map = { 0: '待付款', 1: '已付款', 2: '已发货', 6: '待评价', 7: '已完成' }
      return map[status] || '-'
    },
    
    goChub() { this.$router.push('/cHub') },
    goUrl(val) { this.$router.push(val) },
    goMoreFunctions() { this.$message.info('更多功能开发中') }
  }
}
</script>

<style lang="scss" scoped>
.alipay-home {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 欢迎横幅
.welcome-banner {
  background: linear-gradient(135deg, #1677ff 0%, #69a5ff 100%);
  border-radius: 20px;
  padding: 24px 32px;
  margin-bottom: 24px;
  color: #fff;
  
  .banner-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    .greeting h2 { font-size: 24px; margin: 0 0 8px 0; font-weight: 500; }
    .greeting p { margin: 0; opacity: 0.85; font-size: 14px; }
    .banner-date { text-align: center; padding: 12px 20px; background: rgba(255,255,255,0.15); border-radius: 12px; }
    .banner-date .date { font-size: 20px; font-weight: 600; }
    .banner-date .week { font-size: 14px; margin-top: 4px; opacity: 0.85; }
  }
  
  .banner-stats {
    display: flex;
    gap: 40px;
    padding-top: 20px;
    border-top: 1px solid rgba(255,255,255,0.2);
    .stat-item { display: flex; flex-direction: column; align-items: center; .stat-num { font-size: 28px; font-weight: 700; } .stat-label { font-size: 13px; opacity: 0.85; margin-top: 4px; } }
  }
}

// 统计卡片
.stat-cards { margin-bottom: 24px; }
.stat-card {
  background: #fff; border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04); transition: all 0.3s ease;
  &:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,0.1); }
  
  .stat-icon { width: 56px; height: 56px; border-radius: 14px; display: flex; align-items: center; justify-content: center; i { font-size: 28px; color: #fff; } }
  .stat-info { flex: 1; .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; } .stat-label { font-size: 13px; color: #8c8f98; margin-top: 6px; } .stat-trend { font-size: 12px; margin-top: 4px; i { margin-right: 2px; } } }
  
  &.hub .stat-icon { background: linear-gradient(135deg, #1677ff, #69a5ff); }
  &.car .stat-icon { background: linear-gradient(135deg, #00b578, #1acd8c); }
  &.pitch .stat-icon { background: linear-gradient(135deg, #ffb980, #ffd666); }
  &.article .stat-icon { background: linear-gradient(135deg, #ef705a, #ff8c6f); }
}

// 卡片通用样式
.function-card, .todo-card, .chart-card, .small-chart-card, .order-card {
  border-radius: 16px; overflow: hidden;
  .card-header { padding: 16px 20px; border-bottom: 1px solid #f0f0f0; display: flex; align-items: center; gap: 8px; i { font-size: 18px; color: #1677ff; } span { flex: 1; font-size: 15px; font-weight: 600; color: #1f2d3d; } .more-btn { color: #1677ff; font-size: 12px; cursor: pointer; } }
}

// 常用功能
.function-list { display: flex; flex-wrap: wrap; padding: 16px; gap: 16px; }
.function-item { width: 85px; display: flex; flex-direction: column; align-items: center; cursor: pointer; transition: all 0.3s;
  &:hover { transform: translateY(-4px); .function-icon { transform: scale(1.05); } span { color: #1677ff; } }
  .function-icon { width: 52px; height: 52px; border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 8px; i { font-size: 26px; color: #fff; } }
  .function-name { font-size: 12px; color: #606266; text-align: center; }
  .hub { background: linear-gradient(135deg, #1677ff, #69a5ff); }
  .wheel { background: linear-gradient(135deg, #00b578, #1acd8c); }
  .pitch { background: linear-gradient(135deg, #ffb980, #ffd666); }
  .article { background: linear-gradient(135deg, #ef705a, #ff8c6f); }
  .category { background: linear-gradient(135deg, #9270ca, #b48add); }
  .car { background: linear-gradient(135deg, #1677ff, #69a5ff); }
}

// 待办事项
.todo-list { padding: 8px 0; }
.todo-item { display: flex; align-items: center; padding: 12px 20px; border-bottom: 1px solid #f5f5f5; cursor: pointer; transition: background 0.2s; &:hover { background: #f8f9fc; } i { font-size: 16px; width: 28px; color: #1677ff; } .todo-title { flex: 1; font-size: 14px; } .todo-badge { padding: 2px 8px; border-radius: 20px; font-size: 12px; margin-right: 12px; &.warning { background: #fdf6ec; color: #e6a23c; } &.danger { background: #fff2f0; color: #ff4d4f; } &.info { background: #e6f4ff; color: #1677ff; } } }

// 图表
.chart-container { height: 280px; padding: 8px; }
.small-chart { height: 220px; padding: 8px; }

// 最近订单表格
.recent-table { padding: 8px 16px; .order-sn { font-family: monospace; color: #1677ff; } .order-amount { color: #ff4d4f; font-weight: 500; } }

@media (max-width: 768px) {
  .welcome-banner { padding: 16px 20px; .greeting h2 { font-size: 18px; } .banner-stats { gap: 20px; .stat-item .stat-num { font-size: 20px; } } }
  .function-list { justify-content: center; }
}
</style>